import { Reveal } from "@/components/landing/Reveal";
import { SectionTitle } from "./ui";

const STEPS = [
  ["Nos contactas", "Por WhatsApp o dejando tus datos en el formulario."],
  ["Analizamos tu situación", "Conversamos sobre tu edad, tu familia, tu previsión actual y lo que buscas."],
  ["Te presentamos alternativas", "Te mostramos opciones que se ajusten a tu caso y te explicamos cada una."],
  ["Te acompañamos en el proceso", "Si decides avanzar, te ayudamos con cada paso hasta el final."],
];

export const HowItWorks = () => (
  <section id="como-funciona" data-testid="how-section" className="bg-white py-16 sm:py-24">
    <div className="mx-auto max-w-6xl px-4 sm:px-6">
      <Reveal><SectionTitle title="¿Cómo funciona?" /></Reveal>
      <ol className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4 lg:gap-6">
        {STEPS.map(([t, d], i) => (
          <Reveal key={t} delay={i * 0.08}>
            <li className="relative" data-testid={`step-${i + 1}`}>
              <div className="flex items-center gap-4">
                <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-[#0B3C5D] text-2xl font-extrabold text-white">{i + 1}</span>
                {i < STEPS.length - 1 && <span className="hidden h-[2px] flex-1 bg-[#D6E2EA] lg:block" aria-hidden="true" />}
              </div>
              <h3 className="mt-5 text-[21px] font-bold text-[#0B3C5D]">{t}</h3>
              <p className="mt-2 text-[17px] leading-relaxed text-[#4A5864]">{d}</p>
            </li>
          </Reveal>
        ))}
      </ol>
    </div>
  </section>
);
